import React from "react";

// ============================================================
// Iter 86 — TreePlacementPrompt
// Post-transfer prompt asking whether the freshly-promoted
// members should be placed in the Follow-Up tree now or later.
// ============================================================
export function TreePlacementPrompt({ count, onSkip, onPlace }) {
  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && onSkip()} data-testid="members-tree-placement-prompt">
      <div className="modal" style={{ maxWidth: 440 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">Place in Follow-Up Tree?</div>
          <button className="modal-close" onClick={onSkip}>×</button>
        </div>
        <div className="modal-body" style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <div style={{ fontSize: 14, color: "var(--kc-text)", lineHeight: 1.5 }}>
            Would you like to place {count === 1 ? "this new member" : `these ${count} new members`} in the Follow-Up tree?
          </div>
          <div style={{ fontSize: 12, color: "var(--kc-sub)", lineHeight: 1.5 }}>
            Placement is optional. Members not placed now can be assigned to a tree slot later from the Follow-Up tree admin tools.
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
            <button
              type="button"
              className="btn btn-outline"
              onClick={onSkip}
              data-testid="members-tree-prompt-skip"
            >
              Skip for Now
            </button>
            <button
              type="button"
              onClick={onPlace}
              data-testid="members-tree-prompt-place"
              style={{
                background: "var(--kc-gold)", color: "#111",
                border: "none", borderRadius: 8,
                padding: "10px 20px",
                fontFamily: "'Cinzel',serif", fontWeight: 700,
                letterSpacing: "0.06em", textTransform: "uppercase",
                fontSize: 12, cursor: "pointer",
              }}
            >
              Place in Tree
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
